module.exports = __webpack_public_path__ + "static/media/arrow-down.e27c6b13.svg";